import React from 'react';

import { TIconType } from '../interface';

const CMModuleIcon: TIconType = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<circle
				cx='6'
				cy='5'
				fill='#4D4DB3'
				r='2'
			/>
			<circle
				cx='18'
				cy='19'
				fill='#4D4DB3'
				r='2'
			/>
			<path
				d='M18 17V7C18 7 18 5 16 5H13M6 7V17C6 17 6 19 8 19H11M18 21C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19C20 18.4696 19.7893 17.9609 19.4142 17.5858C19.0391 17.2107 18.5304 17 18 17C17.4696 17 16.9609 17.2107 16.5858 17.5858C16.2107 17.9609 16 18.4696 16 19C16 19.5304 16.2107 20.0391 16.5858 20.4142C16.9609 20.7893 17.4696 21 18 21V21ZM6 7C6.53043 7 7.03914 6.78929 7.41421 6.41421C7.78929 6.03914 8 5.53043 8 5C8 4.46957 7.78929 3.96086 7.41421 3.58579C7.03914 3.21071 6.53043 3 6 3C5.46957 3 4.96086 3.21071 4.58579 3.58579C4.21071 3.96086 4 4.46957 4 5C4 5.53043 4.21071 6.03914 4.58579 6.41421C4.96086 6.78929 5.46957 7 6 7V7Z'
				stroke='#4D4DB3'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15 7.5L12.5 5L15 2.5M8.5 16.5L11 19L8.5 21.5'
				stroke='#4D4DB3'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CMModuleIcon;
